import React, { ReactNode } from 'react';

import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveSearchDrawerItemContent,
  ResponsiveSearchDrawerItemText,
  ResponsiveSearchDrawerItemTitle,
  ResponsiveSearchDrawerItemSubtitle,
} from '../styled';

type CustomIconProps = React.ComponentType<
  React.SVGProps<SVGSVGElement> | CustomIconComponentProps
>;
export interface ResponsiveDrawerInterface {
  icon?:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps
      >
    | React.ComponentClass<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps,
        any
      >
    | undefined;

  title?: string;
  subTitle?: string | ReactNode;
  arrowIcon?: boolean;
  onClick?:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined;

  className?: string;
  placeholder?: string;
  arrowIconType?: CustomIconProps;
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  isSubmit?: boolean;
}

const CarRentalMobilDateSelect: React.FC<ResponsiveDrawerInterface> = ({
  icon,
  title,
  subTitle,
  arrowIcon,
  onClick = () => false,
  className,
  placeholder,
  arrowIconType = DownArrowIcon,
}) => {
  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
      className={className}
    >
      <CustomIcon icon={icon} fontSize={28} paletteColor='primaryBrand' />
      <div style={{ width: 15 }} />
      <ResponsiveSearchDrawerItemText>
        <ResponsiveSearchDrawerItemTitle>
          {title}
        </ResponsiveSearchDrawerItemTitle>
        <br />
        <ResponsiveSearchDrawerItemSubtitle isEmpty={!subTitle}>
          {subTitle || placeholder}
        </ResponsiveSearchDrawerItemSubtitle>
      </ResponsiveSearchDrawerItemText>

      {arrowIcon && <CustomIcon fontSize={16} icon={arrowIconType} />}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default CarRentalMobilDateSelect;
